export default {
    pdfs: process.env.VUE_APP_SERVER + 'indicadores/app/views/assistant/pdf/'
}